export default "__VITE_ASSET__23fa5c10__"